import React from 'react';
import { SignInPage } from '../components/ui/sign-in';
import { RbcAttributionShort } from '../components/RbcAttribution';

const Login: React.FC = () => {
  const handleSignIn = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const email = formData.get('email') as string;
    const password = formData.get('password') as string;
    
    try {
      const response = await fetch('/update-feed/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          username: email,
          password: password,
        }),
      });
      
      if (response.ok) {
        // Land CA-leadership users on their tailored home; everyone else on the feed.
        const data = await response.json().catch(() => ({}));
        window.location.href = data.role === 'ca_user' ? '/ca-home' : '/update-feed';
      } else {
        alert('Invalid credentials. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred during login. Please try again.');
    }
  };

  const handleResetPassword = () => {
    alert("Password reset functionality not yet implemented");
  };

  return (
    <div className="bg-background text-foreground">
      <SignInPage
        title={
          <span className="font-light text-foreground tracking-tighter">
            Welcome to <span className="font-semibold text-green-600">NatureScan</span>
          </span>
        }
        description=""
        heroImageSrc="https://images.unsplash.com/photo-1486162928267-e6274cb3106f?q=80"
        onSignIn={handleSignIn}
        onResetPassword={handleResetPassword}
        footer={<RbcAttributionShort />}
      />
    </div>
  );
};

export default Login;
